import React, { useState } from 'react';
import { Result } from 'models/Search';
import PlaceholderImage from './PlaceholderImage';
import LazyImage from 'shared/assets/LazyImage';

export interface ResultImageProps {
	item: Result;
	onClick?: () => void;
	//#region HCL
	search?: string;
	//#endregion
}

interface OptionalAnchorProps {
	href?: string;
	children?: JSX.Element;
	name?: string;
	onClick?: () => void;
}

const OptionalAnchor = ({ href, children, name, onClick }: OptionalAnchorProps) => {
	return href ? (
		<a className="hawk-results__item-image-link" href={href} onClick={() => onClick && onClick()}>
			<span className="roc-visually-hidden">{name}</span>
			{children}
		</a>
	) : (
		<>{children}</>
	);
};

function ResultImage({ item, onClick /*#region HCL */, search /*endregion*/ }: ResultImageProps) {
	const imageUrl = item.getDocumentValue('image') ?? '';
	const itemName = item.getDocumentValue('name');
	const url = item.getDocumentValue('url_detail');
	// #region HCL
	const roctype = item.getDocumentValue('roctype');
	// #endregion
	const [hasImage, setHasImage] = useState(imageUrl !== '' && !!imageUrl);
	const [imageLoaded, setImageLoaded] = useState(false);

	return (
		<div className="hawk-results__item-image">
			<div style={imageLoaded ? {} : { overflow: 'hidden', width: '0px', height: '0px' }}>
				{hasImage ? (
					<OptionalAnchor
						href={url /*#region HCL */ + (search || '') /*endregion*/}
						onClick={() => onClick && onClick()}
						name={itemName}
					>
						<LazyImage
							src={imageUrl}
							alt={`Image for ${itemName}`}
							onLoad={() => setImageLoaded(true)}
							onError={() => {
								setHasImage(false);
								setImageLoaded(false);
							}}
						/>
					</OptionalAnchor>
				) : null}
			</div>

			{!imageLoaded ? (
				// if the main image hasn't loaded yet, show a placeholder
				<OptionalAnchor
					href={url /*#region HCL */ + (search || '') /*endregion*/}
					onClick={onClick}
					name={itemName}
				>
					<>
						{/* #region HCL */}
						{roctype === 'Page' || roctype === 'ContentPage' ? (
							<img src="/images/content-tool-page-image-not-found.jpg" alt={`${itemName}`} />
						) : (
							<PlaceholderImage showSpinner={hasImage} />
						)}
						{/* #endregion */}
					</>
				</OptionalAnchor>
			) : null}
		</div>
	);
}

export default ResultImage;
